import { QaroniCache } from '@qaroni-core/types/qaroni-cache/qaroni-cache';
import { EmployeeCheckSource } from './employee-check-source';

export class EmployeeConfigurationCheckCache extends QaroniCache<EmployeeCheckSource> {
  public canReturn(employeeID: number): boolean {
    return (
      !!this.get() &&
      !!this.get().employeeId &&
      this.get().employeeId === employeeID
    );
  }

  public canApi(employeeID: number): boolean {
    return !this.canReturn(employeeID) && !this.flying ? true : false;
  }
}
